// duck/index.js
import privacyReducer from './reducers';
export { default as privacyOperations } from './operations';
export default privacyReducer;